import EasyCommLogo from '../../../../assets/image/Channels/EasyComm.png'
import UCLogo from '../../../../assets/image/Channels/unicommerce.png'
import ClickPostLogo from '../../../../assets/image/Channels/ClickPost.svg'
import VinculumLogo from '../../../../assets/image/Channels/vinculum.png'
import OmsGuruLogo from '../../../../assets/image/Channels/OmsGuru.png'
import EasyShipLogo from '../../../../assets/image/Channels/EasyShip.svg'
import Amazon from '../../../../assets/image/Channels/Amazon.png'
import Flipkart from '../../../../assets/image/Channels/flipkart.png'
import WooCommerce from '../../../../assets/image/Channels/woocommerce.png'
import Shopify from '../../../../assets/image/Channels/Shopify.png'
import OpenCart from '../../../../assets/image/Channels/OpenCart.png'
import Magento from '../../../../assets/image/Channels/MagentoChannel.png'
import StoreHippo from '../../../../assets/image/Channels/storeHippo.png'

export const CarrierPartners = [
    {
        name: 'EasyEcom',
        description: 'AI-powered omnichannel platform for inventory, warehousing, payment reconciliation, and wholesale management.',
        image: EasyCommLogo,
    },
    {
        name: 'Unicommerce',
        description: 'Efficient e-commerce solutions to simplify courier and logistics management for businesses.',
        image: UCLogo,
    },
    {
        name: 'ClickPost',
        description: 'Comprehensive logistics management platform for businesses of all sizes.',
        image: ClickPostLogo,
    },
    {
        name: 'Vinculum',
        description: 'Integrated courier services as part of Vinculum’s advanced e-commerce and omnichannel solutions.',
        image: VinculumLogo,
    },
    {
        name: 'OMS Guru',
        description: 'Order fulfillment tools that optimize courier operations for e-commerce businesses.',
        image: OmsGuruLogo,
    },
    {
        name: 'EasyShip',
        description: 'Global shipping and courier automation platform for businesses of all sizes.',
        image: EasyShipLogo,
    },
    {
        name: 'Amazon',
        description: 'Amazon’s logistics and fulfillment services for efficient e-commerce delivery.',
        image: Amazon,
    },
    {
        name: 'Flipkart',
        description: 'Flipkart’s in-house courier and shipping solutions for sellers and businesses.',
        image: Flipkart,
    },
    {
        name: 'WooCommerce',
        description: 'Open-source e-commerce plugin for WordPress with seamless shipping integrations.',
        image: WooCommerce,
    },
    {
        name: 'Shopify',
        description: 'E-commerce platform offering integrated shipping and logistics support for merchants.',
        image: Shopify,
    },
    {
        name: 'OpenCart',
        description: 'Feature-rich e-commerce solution with multiple shipping and carrier integrations.',
        image: OpenCart,
    },
    {
        name: 'Magento',
        description: 'Scalable e-commerce platform with built-in logistics and fulfillment support.',
        image: Magento,
    },
    {
        name: 'Store Hippo',
        description: 'Next-gen e-commerce platform with multi-channel shipping and logistics capabilities.',
        image: StoreHippo,
    },
];
